// extracted by mini-css-extract-plugin
module.exports = {"feedbackText":"FeedbackDisplay_feedbackText__8bzWt"};